import configServices from "@/services/config";

const state = {
  allConfigs: configServices.getAllConfigs() || [],
};

const getters = {
  allConfigs(state) {
    return state.allConfigs;
  },
};

const mutations = {
  SET_ALL_CONFIGS: (state, allConfigs) => {
    state.allConfigs = allConfigs;
  },
};

const actions = {
  setAllConfigs({ commit }, data) {
    commit("SET_ALL_CONFIGS", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
